<template>
  <div id="header" class="header">
    <div class="logo" v-if="status === 3 || status === 0">
      <a target="_blank" href="http://www.unischool.cn/">
        <img src="@/assets/unischool.png">
      </a>
    </div>
    <div class="logo" v-if="status === 1 || status === 2 || haspc">
      <a :href="`pc.html#/?source=${source?source:''}`">
        <img src="@/assets/logob.png">
      </a>
    </div>
    <ul class="manbtn" v-if="status === 1 || status === 2">
      <li :class='[select=="bookshelf" ? "active" : ""]' @click="gostate('/')">书库</li>
      <li :class='[select=="hasread" ? "active" : ""]' @click="gostate('/hasread')">最近阅读</li>
      <li :class='[select=="hasbuy" ? "active" : ""]' @click="gostate('/hasbuy')">已购买</li>
    </ul>
    <ul class="manbtn" v-if="status === 3">
      <li :class='[select=="noworder" ? "active" : ""]' @click="gostate('/')">当前订单</li>
      <li :class='[select=="hisorder" ? "active" : ""]' @click="gostate('/hisorder')">历史订单</li>
      <li v-if="hasreturn" @click="goReturn()">返回</li>
    </ul>
    <ul class="subbtn" v-if="status !== 0 && source !== 'TJ'">
      <li v-if="status === 2 || status === 3">欢迎您，<span class="username">{{showName}}</span><span @click="goexit()">[退出]</span></li>
      <li v-if="status === 1"><a class="active" href="login.html">登录</a></li>
      <li v-if="status === 1"><a target="_blank" href="https://tjebook.nse.cn/ucenter/user/insert.nse?url=https://tjebook.nse.cn/t/login.html&roleId=3&appid=EBOOK">注册</a></li>
      <li><a target="_blank" href="http://www.unischool.cn/c/2016-07-12/102958.shtml?mmid=null">帮助</a></li>
      <!-- <li><a target="_blank" href="http://www.unischool.cn/unischool/message/list?boardId=21&SiteID=42">建议反馈</a></li> -->
<!--      <li><a v-if="status === 1 || status === 2" href="http://ebook.nse.cn/CourseWeb/nb2/nb.html">回到旧版</a></li>-->
    </ul>
  </div>
</template>

<script>
import { param2Obj } from '@/utils'
export default {
  name: 'header-main',
  props: {
    status: Number, // 0 登录页面 1 书架 2 书架登录成功 3 订单
    select: String
  },
  data() {
    return {
      hasreturn: false,
      haspc: false,
      source: '' // 天津教材增加字段
    }
  },
  computed: {
    showName: function() {
      let re = ''
      console.log(this.$store.getters.hasPurchased)
      const user = this.$store.getters.user
      if (user.openid && user.openid.length > 8) {
        re = user.nickname
      }
      re = user.username
      if (re && re.length > 20) {
        re = re.substring(0, 18) + '...'
      }
      return re
    }
  },
  created() {
    const para = param2Obj()
    this.source = para.source
    if (para && para.reurl) {
      this.hasreturn = true
      if (para.reurl.indexOf('pc.html') !== -1) {
        this.haspc = true
      }
    } else {
      this.hasreturn = false
    }
  },
  methods: {
    goReturn() {
      const para = param2Obj()
      if (para && para.reurl) {
        window.location.href = decodeURIComponent(para.reurl)
      }
    },
    gostate(key) {
      if (this.$router) {
        this.$router.push({ 'path': key })
      }
    },
    goexit() {
      this.$store.dispatch('resetUserToken').then(() => {
        if (this.$router) {
          this.$router.push({ 'path': '/' })
        } else {
          window.location.href = 'login.html?re=' + encodeURIComponent(window.location.href)
        }
      }).catch(() => { // 此处如果处理了异常页面就进入无限循环了，不知道原因
        console.log('resetUserToken catch ')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/common/styles/variables.scss';
  .header{
    color: $theme-main-color;
    height: $header-height;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .logo{
      margin-left: 22px;
      img{
        height: 50px;
        width: auto;
      }
    }
    ul{
      display: flex;
      li{
        list-style: none;
        cursor: pointer;
      }
      a{
        text-decoration: none;
        color: $theme-main-color;
      }
      a:hover{
        color: $theme-primary-color;
      }
    }
    .manbtn{
      word-break: keep-all;
      flex-grow: 2;
      li{
        padding: 12px 0px;
        margin: 0 20px;
        font-size: 18px;
        border-bottom: solid 2px $theme-re-color;
      }
      li:hover{
        color: $theme-primary-color;
      }
      li.active{
        color: $theme-primary-color;
        border-bottom: solid 2px $theme-primary-color;
      }
    }
    .subbtn{
      word-break: keep-all;
      font-size: 14px;
      padding-right: 14px;
      li{
        padding: 8px;
      }
      li .username,
      a.active,
      li.active{
        color: $theme-primary-color;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Layout/components/Header.vue